import { useState, useEffect } from "react";
import {
  WhatsappShareButton,
  LinkedinShareButton,
  FacebookShareButton,
} from "react-share";
import clipboardCopy from "clipboard-copy";
import { useLocation, useNavigate } from "react-router-dom";
import Backround from "../assets/bg-img2.png";
import headSet from "../assets/headSet.png";
import watch from "../assets/watch.png";
import foodCoupon from "../assets/foodCoupon.png";
import blnt from "../assets/blnt.png";
import screenShot from "../assets/screenShot.png";
import CircleIcon from "../assets/CircleIcon";

const CongratulationsScreen = () => {
  const navigate = useNavigate();
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [clipCopy, setClipCopy] = useState(false);
  const { state } = useLocation();
  const defaultShareData = {
    title: "Freston New Year Quest ",
    text: "Let’s welcome 2024 with the Freston Scratch Card Quest to reveal Your New Year's Surprise!",
    url: window.location.origin,
  };
  const getPrizeImage = (prize) => {
    switch (prize) {
      case "20%":
        return watch;
      case "15%":
        return headSet;
      // case "Food Coupon":
      //   return foodCoupon;
      case "Next Time Bro":
        return blnt;

      default:
        return blnt;
    }
  };
  useEffect(() => {
    if (!state) {
      navigate("/");
    }
  }, [navigate, state]);

  const shareWinnerImage = async () => {
    try {
      const response = await fetch(screenShot);
      const blob = await response.blob();
      const file = new File([blob], "screenShot.png", { type: "image/png" });

      const shareData = {
        files: [file],
        ...defaultShareData,
      };

      await navigator.share(shareData);
      console.log("Image shared successfully");
    } catch (error) {
      console.log("Error sharing image:", error);
      // Handle error
    }
  };
  const backGround = {
    // background: `url(${Backround}) bottom,linear-gradient(171deg, #9163EA 13.56%, #7554DE 35%, #3B34C6 82.8%)`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center bottom",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
    padding: "4vh 0",
    backgroundSize: "100% 68%, 100% 100%",
    alignItems: "center",
  };

  const shareTitle = `ProSEED Scholarship`;
  const shareText = `Congratulations
  You've won ${
    state?.prize
  } course fee waiver , your offer code is ${state.scratchDetails?.code?.toUpperCase()}.
  Please connect with us at
  7736458999`;
  const shareHashTag = `#KTX #Proseed #FrestonAnalytics #CourseOffer`;
  const shareUrl = `https://scholarship.theproseed.io/`;

  return (
    <>
      <div style={backGround} className="full-screen-div overflow-y-scroll">
        <div className="flex h-full flex-col px-7 items-center justify-around overflow-y-auto overflow-x-hidden">
          <div className="text-[#fff] pb-1 flex flex-col items-center">
            <h1 className="text-[#3fc6f0] text-[20px] text-center font-bold p">
              Congratulations 🎉
            </h1>
            <h5 className="font-normal text-lg">You’ve hit the jackpot!</h5>
          </div>

          <div className="flex flex-col pb-1 items-center  justify-center">
            <div
              className=""
              style={{
                position: "relative",
                display: "flex",
                width: "80vw",
                height: "80vw",
                maxHeight: "358px",
                maxWidth: "358px",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                backgroundColor: "red",
                strokeColor: "black",
                background: "rgba(255, 255, 255, 0.5)",
                boxShadow: "rgba(255, 255, 255, 0.25) 0px 0px 0px 20px",
              }}
            >
              <div className="container">
                <div>
                  <div
                    style={{
                      width: "25px",
                      height: "49px",
                      position: "absolute",
                      left: "0",
                      top: "0",
                      transform: "translate(-11px, -177px",
                    }}
                    className="buble-icons-top"
                  >
                    <div className="">
                      <CircleIcon fill="#fff" variant="sm" />
                      <CircleIcon fill="#fff" />
                      <CircleIcon variant="lg" />
                    </div>
                  </div>
                  <div
                    style={{
                      width: "25px",
                      height: "49px",
                      position: "absolute",
                      right: "0",
                      bottom: "0",
                      transform: "translate(-11px, 177px",
                    }}
                    className="buble-icons-bottom"
                  >
                    <div className="">
                      <CircleIcon fill="#fff" variant="sm" />
                      <CircleIcon fill="#fff" />
                      <CircleIcon variant="lg" />
                    </div>
                  </div>
                </div>
                <div className="base">
                  <p
                    style={{
                      backgroundColor: "#c541b7",
                      color: "white",
                      padding: "6px 12px",
                      borderRadius: "12px",
                      textAlign: "center",

                      position: "absolute",
                      top: 50,
                    }}
                  >
                    {state.scratchDetails?.code?.toUpperCase()}
                  </p>
                  <img
                    className="justify-start items-center inline-flex"
                    src={getPrizeImage(state?.prize)}
                    alt="price"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col pb-2">
            <div className="font-normal text-lg text-center text-[white] pb-4">
              <p>Avail the offer and secure your spot today</p>
            </div>
            <div className="flex items-center w-full justify-center relative pb-4">
              <button
                onTouchStart={() => {
                  // if (navigator.share) {
                  //   shareWinnerImage();
                  // } else {
                  setIsShareOpen(true);
                  // }
                }}
                onClick={() => {
                  // if (navigator.share) {
                  //   shareWinnerImage();
                  // } else {
                  setIsShareOpen(true);
                  // }
                }}
                className="bg-[#faa219] rounded-3xl text-black  px-6 py-3  w-full flex items-center text-bold text-2xl  justify-center"
              >
                <span>My Scholarship</span>
              </button>
            </div>
            {/* <div className="flex w-full items-center justify-center">
              <svg
                className="me-4"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 7C8.34262 7 7 8.3431 7 10C7 11.6573 8.34312 13 10 13C11.6573 13 13 11.6569 13 10C13 8.3427 11.6569 7 10 7ZM10 5C12.7604 5 15 7.2371 15 10C15 12.7605 12.7629 15 10 15C7.23953 15 5 12.7629 5 10C5 7.23953 7.2371 5 10 5ZM16.5 4.74915C16.5 5.43926 15.9392 5.99917 15.25 5.99917C14.5599 5.99917 14 5.4384 14 4.74915C14 4.0599 14.5607 3.5 15.25 3.5C15.9383 3.49913 16.5 4.0599 16.5 4.74915ZM10 2C7.52552 2 7.1222 2.00655 5.97129 2.0578C5.18717 2.09461 4.66155 2.20007 4.17318 2.38967C3.73918 2.55799 3.42611 2.75898 3.09254 3.09255C2.75769 3.4274 2.55706 3.73963 2.38942 4.17383C2.19938 4.66332 2.09395 5.18811 2.0578 5.97115C2.00605 7.0752 2 7.46105 2 10C2 12.4745 2.00655 12.8778 2.05779 14.0286C2.09462 14.8124 2.20022 15.3388 2.38936 15.826C2.55812 16.2606 2.75952 16.5744 3.09148 16.9064C3.42765 17.2421 3.74081 17.4434 4.17089 17.6094C4.66521 17.8005 5.1905 17.9061 5.97114 17.9422C7.0752 17.9939 7.46105 18 10 18C12.4745 18 12.8778 17.9934 14.0286 17.9422C14.8107 17.9055 15.3375 17.7996 15.826 17.6106C16.2594 17.4423 16.5742 17.2402 16.9064 16.9085C17.2426 16.5718 17.4435 16.2594 17.6097 15.8283C17.8003 15.3358 17.9061 14.8098 17.9422 14.0289C17.9939 12.9248 18 12.5389 18 10C18 7.52552 17.9934 7.12221 17.9422 5.97137C17.9054 5.18906 17.7995 4.66149 17.6103 4.17318C17.4424 3.74038 17.2407 3.42635 16.9074 3.09255C16.572 2.75715 16.2606 2.55693 15.8261 2.38942C15.337 2.19954 14.8114 2.09396 14.0288 2.05781C12.9248 2.00605 12.5389 2 10 2ZM10 0C12.7166 0 13.0558 0.00999994 14.1225 0.0599999C15.1866 0.10917 15.9125 0.2775 16.55 0.525C17.2091 0.77917 17.7658 1.1225 18.3216 1.67833C18.8766 2.23417 19.22 2.7925 19.475 3.45C19.7216 4.08667 19.89 4.81333 19.94 5.8775C19.9875 6.94417 20 7.28333 20 10C20 12.7167 19.99 13.0558 19.94 14.1225C19.8908 15.1867 19.7216 15.9125 19.475 16.55C19.2208 17.2092 18.8766 17.7658 18.3216 18.3217C17.7658 18.8767 17.2066 19.22 16.55 19.475C15.9125 19.7217 15.1866 19.89 14.1225 19.94C13.0558 19.9875 12.7166 20 10 20C7.28333 20 6.94416 19.99 5.8775 19.94C4.81333 19.8908 4.08833 19.7217 3.45 19.475C2.79166 19.2208 2.23416 18.8767 1.67833 18.3217C1.1225 17.7658 0.78 17.2067 0.525 16.55C0.2775 15.9125 0.11 15.1867 0.0600002 14.1225C0.0125002 13.0558 0 12.7167 0 10C0 7.28333 0.0100002 6.94417 0.0600002 5.8775C0.10916 4.8125 0.2775 4.0875 0.525 3.45C0.77916 2.79167 1.1225 2.23417 1.67833 1.67833C2.23416 1.1225 2.7925 0.78 3.45 0.525C4.0875 0.2775 4.8125 0.11 5.8775 0.0599999C6.94416 0.0124999 7.28333 0 10 0Z"
                  fill="white"
                />
              </svg>
              <svg
                className="me-4"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M5.25263 16.4944L5.97736 16.917C7.18811 17.623 8.56412 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 11.4363 2.37723 12.8128 3.08368 14.0238L3.50606 14.7478L2.85257 17.1494L5.25263 16.4944ZM0.00418019 20L1.35614 15.0315C0.49396 13.5536 0 11.8345 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C8.16612 20 6.44753 19.5064 4.96988 18.6447L0.00418019 20ZM6.39134 5.30833C6.52522 5.29892 6.65955 5.29748 6.79361 5.30402C6.84777 5.30758 6.90167 5.31384 6.95561 5.32007C7.11487 5.33846 7.29 5.43545 7.34888 5.56894C7.6472 6.24536 7.93666 6.92565 8.21722 7.60963C8.27912 7.76062 8.24182 7.95633 8.12402 8.1457C8.06422 8.2428 7.9703 8.379 7.8615 8.5183C7.74841 8.663 7.50501 8.9291 7.50501 8.9291C7.50501 8.9291 7.4064 9.0473 7.44357 9.1944C7.45805 9.25 7.50423 9.331 7.5461 9.3991C7.56929 9.4368 7.59082 9.4705 7.60479 9.4938C7.86071 9.9211 8.20472 10.3543 8.62492 10.7616C8.74532 10.8783 8.86212 10.9974 8.98772 11.108C9.45602 11.5209 9.98582 11.8583 10.558 12.1082L10.5631 12.1105C10.6476 12.1469 10.691 12.1668 10.8147 12.2193C10.8771 12.2457 10.9409 12.2685 11.0064 12.2858C11.0301 12.292 11.0544 12.2955 11.0788 12.2972C11.2405 12.3069 11.334 12.2032 11.3739 12.1555C12.0974 11.279 12.1636 11.2218 12.1686 11.2222V11.2238C12.2637 11.1236 12.4132 11.0888 12.5466 11.097C12.6075 11.1007 12.6681 11.1124 12.7235 11.1377C13.2553 11.3803 14.1248 11.7587 14.1248 11.7587L14.7063 12.0201C14.8037 12.0671 14.8926 12.1778 14.8969 12.2854C14.8995 12.3523 14.9067 12.4603 14.8828 12.6579C14.8515 12.9166 14.7728 13.2281 14.6946 13.3913C14.6396 13.5058 14.5684 13.6074 14.4856 13.6934C14.3733 13.81 14.2899 13.8808 14.1549 13.9814C14.0727 14.0426 14.0301 14.0714 14.0301 14.0714C13.8912 14.159 13.8129 14.2028 13.6474 14.2909C13.39 14.428 13.1056 14.5068 12.8143 14.5218C12.6286 14.5313 12.4434 14.5447 12.2579 14.5347C12.2497 14.5342 11.6897 14.4482 11.6897 14.4482C10.2678 14.0742 8.95282 13.3736 7.84936 12.402C7.62375 12.2034 7.41452 11.9885 7.20096 11.7759C6.3119 10.8908 5.63884 9.9364 5.23071 9.0336C5.02945 8.5884 4.90201 8.1116 4.9 7.62098C4.89631 7.01405 5.09501 6.4232 5.46471 5.94186C5.53759 5.84697 5.60676 5.74855 5.72611 5.63586C5.8525 5.51651 5.93294 5.45244 6.01959 5.40811C6.13509 5.34902 6.26195 5.31742 6.39134 5.30833Z"
                  fill="white"
                />
              </svg>
              <svg
                className="me-4"
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M11 17.9381C14.9463 17.446 18 14.0796 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.0796 5.05369 17.446 9.00002 17.9381V12H7V10H9.00002V8.3458C9.00002 7.00855 9.13922 6.52362 9.40072 6.03473C9.66212 5.54584 10.0458 5.16216 10.5347 4.9007C10.9174 4.69604 11.3921 4.57252 12.2217 4.51954C12.5509 4.49851 12.9771 4.52533 13.5 4.6V6.5H13C12.0827 6.5 11.7042 6.54332 11.4779 6.66433C11.3376 6.73939 11.2394 6.83758 11.1643 6.97793C11.0433 7.20418 11 7.42853 11 8.3458V10H13.5L13 12H11V17.9381ZM10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20Z"
                  fill="white"
                />
              </svg>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M9.7143 6.91434C10.7624 5.84374 12.127 5.14286 13.7143 5.14286C17.1857 5.14286 20 7.95703 20 11.4286V20H17.7143V11.4286C17.7143 9.21943 15.9234 7.42857 13.7143 7.42857C11.5052 7.42857 9.7143 9.21943 9.7143 11.4286V20H7.42859V5.71429H9.7143V6.91434ZM1.71428 3.42857C0.767508 3.42857 0 2.66106 0 1.71429C0 0.767509 0.767508 0 1.71428 0C2.66105 0 3.42857 0.767509 3.42857 1.71429C3.42857 2.66106 2.66105 3.42857 1.71428 3.42857ZM0.571428 5.71429H2.85714V20H0.571428V5.71429Z"
                  fill="white"
                />
              </svg>
            </div> */}
          </div>
        </div>
      </div>
      {isShareOpen && (
        <div
          className="share-wrapper full-screen-div"
          style={{
            position: "fixed",
            top: "0",
            left: "0",
          }}
          onClick={() => {
            setIsShareOpen(false);
            setClipCopy(false);
          }}
        >
          <div
            className="share-container rounded-t-3xl px-8 flex flex-col justify-between pb-6 gap-4"
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={{
              width: "100%",
              background: "white",
              position: "absolute",
              bottom: "0",
            }}
          >
            <div className="w-full grid justify-center pt-2">
              <div className="w-[62px] h-[5px] bg-[#B9B9B9]"></div>
            </div>
            <div className="">
              <p className="text-xl font-bold">Share to</p>
              <p className="text-base">Share this link via</p>
            </div>
            <div
              style={{ maxWidth: "480px" }}
              className="flex items-center justify-between"
            >
              {/* facebook */}
              <FacebookShareButton
                url={shareUrl}
                quote={shareText}
                hashtag={shareHashTag}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="52"
                  height="52"
                  viewBox="0 0 52 52"
                  fill="none"
                >
                  <path
                    d="M25.641 3.75197C37.8452 3.75197 47.7739 13.6806 47.7739 25.8848C47.7739 38.089 37.8452 48.0176 25.641 48.0176C13.4368 48.0176 3.50821 38.089 3.50821 25.8848C3.50821 13.6806 13.4368 3.75197 25.641 3.75197ZM25.641 0.243774C11.4728 0.243774 0 11.7301 0 25.8848C0 40.0395 11.4863 51.5258 25.641 51.5258C39.8093 51.5258 51.2821 40.0395 51.2821 25.8848C51.2821 11.7301 39.8093 0.243774 25.641 0.243774Z"
                    fill="#1E4FAD"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M28.946 16.3626C29.8807 16.3355 30.8153 16.3491 31.7499 16.3491C31.8583 16.3491 31.9802 16.3491 32.1292 16.3491V11.4999C31.628 11.4457 31.1133 11.378 30.585 11.3509C29.6233 11.3103 28.6751 11.2561 27.7134 11.2832C26.2505 11.3103 24.8689 11.676 23.6634 12.5429C22.2818 13.5452 21.5097 14.9404 21.2253 16.5929C21.1034 17.2702 21.0763 17.988 21.0627 18.6788C21.0357 19.7624 21.0627 20.8596 21.0627 21.9432V22.3496H16.4167V27.7677H21.0356V41.3941H26.6704V27.7948H31.2758C31.5061 25.9932 31.7363 24.2053 31.9802 22.3496C31.6144 22.3496 31.2758 22.3496 30.9507 22.3496C29.6368 22.3496 26.6434 22.3496 26.6434 22.3496C26.6434 22.3496 26.6569 19.6677 26.684 18.5028C26.7111 16.8909 27.6592 16.4032 28.946 16.3626Z"
                    fill="#1E4FAD"
                  />
                </svg>
              </FacebookShareButton>

              {/* whatsapp */}
              <WhatsappShareButton
                url={shareUrl}
                title={`${shareTitle} - ${shareText}`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="52"
                  height="52"
                  viewBox="0 0 52 52"
                  fill="none"
                >
                  <path
                    d="M25.9123 3.9822C38.1165 3.9822 48.0451 13.9108 48.0451 26.115C48.0451 38.3192 38.1165 48.2478 25.9123 48.2478C13.7081 48.2478 3.77944 38.3192 3.77944 26.115C3.77944 13.9244 13.7081 3.9822 25.9123 3.9822ZM25.9123 0.473999C11.744 0.473999 0.27124 11.9603 0.27124 26.115C0.27124 40.2697 11.7575 51.756 25.9123 51.756C40.0805 51.756 51.5533 40.2697 51.5533 26.115C51.5533 11.9603 40.067 0.473999 25.9123 0.473999Z"
                    fill="#0B8F21"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.3669 39.7415C12.5295 39.1319 12.6649 38.5901 12.8004 38.0619C13.2609 36.3552 13.7486 34.6485 14.1956 32.9418C14.2633 32.6844 14.2362 32.3458 14.1143 32.1155C9.77983 23.853 14.2497 13.8566 23.3385 11.73C31.6011 9.79308 39.0103 15.3602 40.3648 22.8236C41.7735 30.5985 36.6941 37.9806 28.9733 39.3351C25.9121 39.8633 22.9728 39.4164 20.1825 38.0483C19.9387 37.9264 19.5865 37.8858 19.3156 37.9535C15.6042 38.8881 13.1255 39.5925 12.3669 39.7415ZM15.6449 36.5042C17.0536 36.1384 18.3404 35.8134 19.6136 35.4612C19.9793 35.3664 20.2502 35.4206 20.5753 35.5966C22.9999 36.9918 25.6006 37.5201 28.3774 37.0731C34.7707 36.0436 39.1458 30.0702 38.1705 23.704C37.1546 17.1075 30.9645 12.6782 24.4221 13.8702C16.5118 15.3195 12.3128 24.1374 16.2409 31.1267C16.6743 31.8988 16.7962 32.5354 16.4982 33.3617C16.1731 34.3505 15.9564 35.3799 15.6449 36.5042Z"
                    fill="#0B8F21"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M30.2059 32.1832C27.4562 32.0884 23.0811 29.9211 20.0741 24.7063C19.004 22.8506 19.1666 20.7375 20.7243 19.2882C21.2525 18.8006 21.9162 18.9224 22.5393 19.0173C22.6883 19.0444 22.8509 19.2746 22.9321 19.4507C23.3385 20.3582 23.7313 21.2658 24.0699 22.2004C24.2596 22.688 23.9209 23.1485 23.203 23.9748C22.9728 24.2322 22.9321 24.476 23.1082 24.774C24.2596 26.7245 25.8715 28.1467 27.998 28.973C28.3096 29.0949 28.5398 29.0136 28.743 28.7698C29.8673 27.4017 29.9756 26.9954 30.5716 27.2798C33.4161 28.6343 33.6328 28.7021 33.6464 29.0136C33.7412 31.4111 31.5333 32.278 30.2059 32.1832Z"
                    fill="#0B8F21"
                  />
                </svg>
              </WhatsappShareButton>
              {/* linkdin */}
              <LinkedinShareButton
                url={shareUrl}
                source={shareUrl}
                summary={shareText}
                title={shareTitle}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="53"
                  height="52"
                  viewBox="0 0 53 52"
                  fill="none"
                >
                  <path
                    d="M26.5475 4.22621C38.7517 4.22621 48.6804 14.1548 48.6804 26.359C48.6804 38.5632 38.7517 48.4919 26.5475 48.4919C14.3433 48.4919 4.41471 38.5632 4.41471 26.359C4.41471 14.1548 14.3298 4.22621 26.5475 4.22621ZM26.5475 0.718018C12.3793 0.718018 0.906494 12.2043 0.906494 26.359C0.906494 40.5138 12.3928 52.0001 26.5475 52.0001C40.7158 52.0001 52.1886 40.5138 52.1886 26.359C52.1886 12.2043 40.7022 0.718018 26.5475 0.718018Z"
                    fill="#007AB5"
                  />
                  <path
                    d="M15.5759 20.9951H20.7772V37.7098H15.5759V20.9951ZM18.1766 12.6919C19.8426 12.6919 21.1836 14.0464 21.1836 15.6989C21.1836 17.365 19.8291 18.7195 18.1766 18.7195C16.5105 18.7195 15.156 17.365 15.156 15.6989C15.156 14.0329 16.5105 12.6919 18.1766 12.6919Z"
                    fill="#007AB5"
                  />
                  <path
                    d="M24.0417 20.9951H29.0264V23.2843H29.0941C29.7849 21.9704 31.4781 20.5887 34.011 20.5887C39.2666 20.5887 40.2418 24.0428 40.2418 28.5533V37.7234H35.054V29.5963C35.054 27.6594 35.0134 25.167 32.3585 25.167C29.6495 25.167 29.2431 27.2801 29.2431 29.4609V37.7369H24.0553V20.9951H24.0417Z"
                    fill="#007AB5"
                  />
                </svg>
              </LinkedinShareButton>
            </div>
            <div className="flex flex-col">
              <p className="text-base">Or copy link</p>
              <div className="flex items-center p-4 h-[41px] bg-[#510DBC] rounded-3xl gap-4 justify-between">
                <div className="flex gap-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M7.69491 6.24606L7.83491 6.38607L8.57491 7.12606C8.76491 6.74606 8.88491 6.33606 8.91491 5.93606C8.93491 5.57606 8.89491 5.20607 8.77491 4.85607C8.65491 4.50607 8.45491 4.18607 8.18491 3.91607L5.00491 0.736077C4.73491 0.466077 4.40491 0.26605 4.06491 0.14605C3.54491 -0.0339502 2.98491 -0.043938 2.44491 0.096062C1.90491 0.236062 1.38491 0.526078 0.954908 0.956078C0.384908 1.52608 0.0549111 2.25608 0.00491111 2.98608C-0.0150889 3.34608 0.0249105 3.71606 0.14491 4.06606C0.26491 4.41606 0.464907 4.73607 0.734907 5.00607L3.91491 8.18606C4.18491 8.45606 4.51491 8.65609 4.85491 8.77608C5.37491 8.95609 5.93491 8.96607 6.47491 8.82607C6.69491 8.76607 6.91491 8.68607 7.12491 8.57607L6.38491 7.83608L6.24491 7.69607C6.11491 7.73607 5.98491 7.75608 5.85491 7.76608C5.63491 7.77608 5.42491 7.75606 5.23491 7.68606C5.04491 7.61606 4.87491 7.51605 4.72491 7.36605L1.54491 4.18606C1.39491 4.03606 1.29491 3.87605 1.22491 3.67605C1.12491 3.39605 1.11491 3.05606 1.19491 2.71606C1.28491 2.37606 1.46491 2.04607 1.75491 1.75607C2.13491 1.37607 2.60491 1.17605 3.04491 1.14605C3.26491 1.13605 3.47491 1.15607 3.66491 1.22607C3.85491 1.29607 4.02491 1.39607 4.17491 1.54607L7.35491 4.72607C7.50491 4.87607 7.60491 5.03605 7.67491 5.23605C7.77491 5.51605 7.78491 5.85607 7.69491 6.19607C7.70491 6.20607 7.69491 6.22606 7.69491 6.24606Z"
                      fill="white"
                    />
                    <path
                      d="M8.14483 9.58611L7.26483 8.70611C7.07483 9.08611 6.95483 9.49611 6.92483 9.89611C6.90483 10.2661 6.94483 10.6261 7.06483 10.9761C7.18483 11.3261 7.38484 11.6461 7.65484 11.9161L10.8348 15.0961C11.1048 15.3661 11.4348 15.5661 11.7748 15.6861C12.2948 15.8661 12.8548 15.8761 13.3948 15.7361C13.9348 15.5961 14.4548 15.3061 14.8848 14.8761C15.4548 14.3061 15.7848 13.5761 15.8348 12.8461C15.8548 12.4861 15.8148 12.1161 15.6948 11.7661C15.5748 11.4161 15.3748 11.0961 15.1048 10.8261L11.9248 7.64611C11.6548 7.37611 11.3248 7.17608 10.9848 7.05608C10.4648 6.87608 9.90484 6.8661 9.36484 7.0061C9.14484 7.0661 8.92483 7.1461 8.71483 7.2561L9.59483 8.1361C9.72483 8.0961 9.85483 8.07609 9.98483 8.06609C10.2048 8.05609 10.4148 8.07611 10.6048 8.14611C10.7948 8.21611 10.9648 8.31612 11.1148 8.46612L14.2948 11.6461C14.4448 11.7961 14.5448 11.9561 14.6148 12.1561C14.7148 12.4361 14.7248 12.7761 14.6348 13.1161C14.5448 13.4561 14.3648 13.7861 14.0748 14.0761C13.6948 14.4561 13.2248 14.6561 12.7848 14.6861C12.5648 14.6961 12.3548 14.6761 12.1648 14.6061C11.9748 14.5361 11.8048 14.4361 11.6548 14.2861L8.47484 11.1061C8.32484 10.9561 8.22484 10.7961 8.15484 10.5961C8.05484 10.3161 8.04483 9.9761 8.13483 9.6361C8.12483 9.6161 8.13483 9.60611 8.14483 9.58611Z"
                      fill="white"
                    />
                    <path
                      d="M8.39502 7.42609L8.31502 7.34613L7.81502 6.84613L7.72502 6.7561L6.36502 5.39612C6.11502 5.14612 5.69501 5.14612 5.44501 5.39612L5.39502 5.44611C5.14502 5.69611 5.14502 6.11609 5.39502 6.36609L6.75502 7.72607L6.84502 7.8161L7.34502 8.3161L7.42502 8.39612L8.01501 8.98608L9.05502 10.0261C9.30502 10.2761 9.72502 10.2761 9.97502 10.0261L10.025 9.97607C10.275 9.72607 10.275 9.30609 10.025 9.05609L8.98502 8.01611L8.39502 7.42609Z"
                      fill="white"
                    />
                  </svg>
                  <p className="text-sm text-white">{shareText}</p>
                </div>
                <div
                  className={`rounded-3xl text-center w-24 p-1 bg-white ${
                    clipCopy ? "" : "cursor-pointer"
                  }`}
                  onClick={() => {
                    clipboardCopy(shareText);
                    setClipCopy(true);
                  }}
                >
                  {clipCopy ? "Copied" : "Copy"}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CongratulationsScreen;
